import axios from "../axiosInstance";
import { handleApiResponse } from "../utils";

// export const fetchRecipeLists = ({ page = 1, limit = 10, query = "", includeIngredients = false }) => {
//  const params = {
//   page,
//   limit,
//   query,
//   includeIngredients,
//  };
//  console.log("includeIngredients 2:>> ", includeIngredients);

//  const url = `/fft/v2/ingredient-list`;
//  return handleApiResponse(() => {
//   return axios.get("/fft/v2/ingredient-list", { params });
//  });
// };

export const fetchRecipeListWithNutrSpecs = recipeListId => {
 const url = `/fft/v2/ingredient-list/${recipeListId}?includeIngredients=true&includeNutrSpecs=true`;
 return handleApiResponse(() => {
  return axios.get(url);
 });
};

export const fetchRecipeLists = async ({ queryKey }) => {
 const [_, params] = queryKey;

 const url = `/fft/v2/ingredient-list`;
 const response = handleApiResponse(async () => {
  return axios.get(url, { params });
 });

 return response;
};

export const fetchRecipeList = (recipeListId, includeIngredients = true) => {
 const url = `/fft/v2/ingredient-list/${recipeListId}?includeIngredients=${includeIngredients}`;
 return handleApiResponse(() => {
  return axios.get(url);
 });
};

export const updateRecipeListIngredients = (recipeListId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/ingredient-list/${recipeListId}/ingredients`, requestBody), "Ingredient list updated successfully");

export const updateRecipeGroups = (recipeListId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/ingredient-list/${recipeListId}/groups`, requestBody), "Ingredient Groups updated successfully");

export const checkNameExists = async (name) => {
 const encodedName = encodeURIComponent(name.trim());
 const url = `/fft/v2/ingredient-list/check-name/${encodedName}`;
 return handleApiResponse(() => {
  return axios.get(url);
 });
};

export const createRecipeList = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/ingredient-list`, requestBody), "Ingredient list created successfully");

export const createRecipeListCopy = (recipeListId, requestBody) =>
 handleApiResponse(() => axios.post(`/fft/v2/ingredient-list/${recipeListId}/copy`, requestBody), "Ingredient list copied successfully");

export const updateRecipeList = (recipeListId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/ingredient-list/${recipeListId}`, requestBody), "Ingredient list updated successfully");

export const deleteRecipeList = recipeListId =>
 handleApiResponse(() => axios.delete(`/fft/v2/ingredient-list/${recipeListId}`), "Ingredient list deleted successfully");

export const getLatestIngredientsPrices = recipeListId => handleApiResponse(() => axios.get(`/fft/v2/ingredient-list/${recipeListId}/prices`));

export const fetchCountries = () => handleApiResponse(() => axios.get(`/general/countries?fft_country=true`));
